// 사용자 동의서 API

import HTTP from 'apiDefault'

const fromServer = (data) => {
  const contents = {
    // 이름 = 카테고리 = 템플릿 이름 = 파일이름
    title: data.name,
    // 필수 항목 필드 id 목록
    requirementIDList: data.userRequirements,
    userRequirements: data.userRequirements,
    // 페이지
    id: data.id,
    server: data,
  }
  return contents
}


//사용자 동의서 템플릿별 리스트
const getList = (companyID, templateID) => {
  return HTTP.get(`/user_agreement/${companyID}/list/${templateID}`
    ,{ headers: { Authorization:window._VUE_STATE.header }, }
    )
}

// 사용자 동의서 내용 조회
// 동의서 id
//사용자 동의서 상세
const get = (companyID, agreementID) => {
  return HTTP.get(`/user_agreement/${companyID}/detail/${agreementID}`
    ,{ headers: { Authorization:window._VUE_STATE.header }, }
  )
}

// 사용자 동의서 삭제
const remove = (accountID, agreementID) => {
  return HTTP.delete(`/user_agreement/${accountID}/delete/${agreementID}`
    ,{ headers: { Authorization:window._VUE_STATE.header }, })
}

// 사용자 동의서 생성
// 관리자 ID, 템플릿 ID, 생성시 추가한 필수 데이터
const create = (companyID, data) => {
  return HTTP.post(`/user_agreement/${companyID}/create`, data
    ,{ headers: { Authorization:window._VUE_STATE.header }, })
}

// 사용자 동의서 업데이트
// 관리자 ID, 템플릿 ID, 생성시 추가한 필수 데이터
const update = (companyID, data) => {
  return HTTP.post(`/user_agreement/${companyID}/update`, data
    ,{ headers: { Authorization:window._VUE_STATE.header }, })
}

const search = (companyID, templateID, page, pageSize, search) => {
  return HTTP.post(`/user_agreement/${companyID}/search/${templateID}?page=${page}&size=${pageSize}`, search
    ,{ headers: { Authorization:window._VUE_STATE.header }, })
}

export {
  getList,
  get,
  create,
  update,
  remove,
  fromServer,
  search,
}



// WEBPACK FOOTER //
// ./src/api/agreement.js